import React, { useEffect, useRef } from 'react';
import GlideJs from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import { useWindowSize } from 'hooks/useWindowSize';
import { useSelector } from 'react-redux';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

const Glide = ({
  className = '',
  options = {},
  noDots = false,
  noControls = false,
  children,
}) => {
  const carouselRef = useRef(null);
  const glideRef = useRef(null);
  const { width } = useWindowSize();
  const { placementStatus, behaviourStatus, attrMobile } = useSelector((state) => state.menu);

  const destroy = () => {
    if (glideRef.current) {
      glideRef.current.destroy();
      glideRef.current = null;
    }
  };

  // 🔥 Proper initialization when slides exist
  useEffect(() => {
    if (!carouselRef.current) return;

    const slides = carouselRef.current.querySelectorAll('.glide__slide');
    if (!slides.length) return;

    destroy();

    glideRef.current = new GlideJs(carouselRef.current, options);
    glideRef.current.mount();

    return () => {
      destroy();
    };
  }, [children, options]);

  // 🔥 Responsive update
  useEffect(() => {
    if (width && glideRef.current) {
      glideRef.current.update();
    }
  }, [width, placementStatus, behaviourStatus, attrMobile]);

  return (
    <div ref={carouselRef} className={`glide ${className}`}>
      <div className="glide__track" data-glide-el="track">
        <div className="glide__slides">{children}</div>
      </div>

      {!noControls && (
        <div className="text-center">
          <span className="glide__arrows slider-nav" data-glide-el="controls">
            <button
              type="button"
              className="btn btn-icon btn-icon-only btn-outline-primary"
              data-glide-dir="<"
            >
              <CsLineIcons icon="chevron-left" />
            </button>
          </span>

          {!noDots && (
            <span className="glide__bullets" data-glide-el="controls[nav]" />
          )}

          <span className="glide__arrows slider-nav" data-glide-el="controls">
            <button
              type="button"
              className="btn btn-icon btn-icon-only btn-outline-primary"
              data-glide-dir=">"
            >
              <CsLineIcons icon="chevron-right" />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

const Item = ({ className = '', children }) => (
  <div className={`glide__slide ${className}`}>{children}</div>
);

Glide.Item = Item;
Glide.Item.displayName = 'Item';

export default Glide;
